export default "__VITE_ASSET__Buww1LIM__";